import React, { useContext, useState } from "react";
import { Button, Grid, makeStyles, FormControl, TextField as MaterialTexField } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { laboratoryServices } from "../services";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ModalBase, TextField } from "./";

export default function AddBusinessUnit(props) {
	const classes = useStyles();
	const { specialtiesList } = props;
	const { register, handleSubmit, errors } = useForm();
	const { authState } = useContext(AuthContext);
	const [specialties, setSpecialties] = useState([]);

	const saveLaboratory = async (dataToInsert) => {
		const laboratory = {
			username: dataToInsert.username,
			email: dataToInsert.email,
			roleId: "5fdb9e3db3bfce86908e4411",
			password: dataToInsert.password,
			laboratory: {
				name: dataToInsert.name,
				laboratoryId: authState.user.laboratory._id,
				specialties,
			},
		};
		try {
			const { status, response } = await laboratoryServices.addLaboratory({ laboratory, token: authState.token });
			switch (status) {
				case 201:
					props.toast(response.message, true);
					props.reload();
					props.close();
					break;
				case 200:
					props.toast(response.error.message, true);
					break;
				case 400:
					props.toast(response.error.message, true);
					break;
				default:
					break;
			}
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<ModalBase open={props.open} close={props.close} title="Agregar unidad de negocio">
			<form className={classes.form} onSubmit={handleSubmit(saveLaboratory)}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="name"
							label="Nombre"
							name="name"
							autoComplete="name"
							placeholder="Nombre"
							size="small"
							inputRef={register({
								required: "Nombre requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.name ? true : false}
							helperText={errors.name ? errors.name.message : ""}
						/>
					</Grid>
					{/*                         <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="region"
                                label="Región"
                                name="region"
                                autoComplete="region"
                                size="small"
                                inputRef={register({
                                    required: "Región requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.region ? true : false}
                                helperText={errors.region ? errors.region.message : ""}
                            />
                        </Grid> */}
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="email"
							label="Correo electrónico"
							name="email"
							size="small"
							placeholder="Correo electrónico"
							autoComplete="email"
							inputRef={register({
								required: "Correo requerido",
								pattern: {
									value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
									message: "Formato de correo inválido",
								},
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.email ? true : false}
							helperText={errors.email ? errors.email.message : ""}
						/>
					</Grid>

					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="username"
							label="Usuario"
							name="username"
							size="small"
							placeholder="Usuario"
							autoComplete="username"
							inputRef={register({
								required: "Usuario requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.username ? true : false}
							helperText={errors.username ? errors.username.message : ""}
						/>
					</Grid>
					<Grid item lg={12} xs={12} sm={12}>
						<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
							<Autocomplete
								multiple
								id="especialidades"
								options={specialtiesList}
								getOptionLabel={(option) => option.name}
								filterSelectedOptions
								variant="outlined"
								label="Especialidades"
								value={specialties}
								onChange={(event, newValue) => {
									setSpecialties(newValue);
								}}
								renderInput={(params) => (
									<MaterialTexField
										{...params}
										id="especialidades"
										name="especialidades"
										variant="outlined"
										label="especialidades"
										placeholder="especialidades"
										inputRef={register({
											validate: (value) => specialties.length || "Debe tener al menos una especialidad.",
										})}
										error={errors.especialidades ? true : false}
										helperText={errors.especialidades ? errors.especialidades.message : ""}
									/>
								)}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="password"
							label="Contraseña"
							name="password"
							size="small"
							placeholder="Contraseña"
							autoComplete="password"
							type="password"
							inputRef={register({
								required: "Contraseña  requerida",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.password ? true : false}
							helperText={errors.username ? errors.password.message : ""}
						/>
					</Grid>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="confirmPassword"
							label="Confirmar contraseña"
							name="confirmPassword"
							size="small"
							placeholder="Confirmar contraseña"
							type="password"
							autoComplete="confirmPassword"
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
				</Grid>
				<Button
					type="submit"
					fullWidth
					size="small"
					variant="contained"
					color="primary"
					className={classes.submit}
					style={{ textTransform: "capitalize", borderRadius: "20px" }}
				>
					Guardar
				</Button>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},

	dialogTitle: {
		textAlign: "Center",
	},
	formControl: {
		width: "100%",
		minWidth: 120,
		"& div": {
			borderRadius: 25,
		},
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
}));
